import { CampaignDocumentController } from './campaign-document.controller'

function campaignDocument () {
  return {
    scope: {
      campaign: '='
    },
    restrict: 'E',
    templateUrl: '/campaigns/directives/campaign-document/campaign-document.html?$$REVISION$$',
    controller: CampaignDocumentController
  }
}

export { campaignDocument }
